import { z } from 'zod'

import type {
  UserSlice,
  YieldbirdDemandReport,
} from 'features/performance/pages/PerformanceYieldbirdDemandPage/hooks/useGetYieldbirdDemandReport'

export const schema = z.object({
  emails: z.array(z.string()),
  id: z.string(),
  yieldbirdDemandReportUrl: z.url().or(z.literal('')),
})

export type Schema = z.infer<typeof schema>

export const defaults = (data: YieldbirdDemandReport): Schema => {
  const { id, users, yieldbirdDemandReportUrl } = data

  return {
    emails: users.map((user: UserSlice): string => user.email),
    id,
    yieldbirdDemandReportUrl: yieldbirdDemandReportUrl || '',
  }
}
